import axios from 'axios';
import { API_BASE_URL } from '../config';

/** GET /credits/profile — balance, lifetime stats, transaction list */
export async function fetchCreditsProfile({ type } = {}) {
    const token = localStorage.getItem('token');
    if (!token || localStorage.getItem('guestUser') === 'true') {
        return null;
    }

    const params = {};
    if (type && type !== 'all') {
        params.type = type === 'earned' ? 'earned' : 'used';
    }

    const { data } = await axios.get(`${API_BASE_URL}/credits/profile`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!data?.success) {
        throw new Error(data?.message || 'Failed to load store credit');
    }

    return data;
}

/** POST /credits/preview — server-side max applicable credit */
export async function previewStoreCredit(orderAmount) {
    const token = localStorage.getItem('token');
    if (!token || localStorage.getItem('guestUser') === 'true') {
        return { balance: 0, creditToApply: 0, payableAfterCredit: orderAmount };
    }

    const { data } = await axios.post(
        `${API_BASE_URL}/credits/preview`,
        { orderAmount: Math.max(0, Number(orderAmount) || 0) },
        { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!data?.success) {
        throw new Error(data?.message || 'Failed to preview store credit');
    }

    return data;
}

export function formatCreditDate(isoOrDate) {
    if (!isoOrDate) return '';
    const d = new Date(isoOrDate);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}
